import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { map, isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { SelectInput } from '../form/selectInput';
import { TextInput } from '../form/textInput';
import { JobClientForm } from '../jobClientForm/jobClientForm';
import { fetchAutoCompleteData } from '@services/autoCompleteService';
import { apiUrls } from '@constants/apiurls';
import styles from '../jobForm/jobForm.module.scss';
import requiredStyles from '../../styles/required.module.scss';

export const JobFormCompanyDetails = (props) => {
  const { 
    clients, 
    clientValue, 
    showClientForm,
    isFetchingClients,
    // Include selectedClient but mark it as optional with a default value
    selectedClient = null
  } = props;

  // Try to get form context but don't crash if it's not available
  const formContext = useFormContext();
  const hasFormContext = !!formContext;
  
  // Get setValue from form context or provide an empty function
  const setValue = hasFormContext ? formContext.setValue : () => {};
  const [open, setOpen] = useState(true);
  
  // Set client_id in the form once on mount and when it changes
  useEffect(() => {
    if (hasFormContext && clientValue) {
      // Set on mount and when clientValue changes
      setValue('client_id', clientValue, { 
        shouldValidate: true, // Run validation
        shouldDirty: true,    // Mark as touched/changed
        shouldTouch: true     // Mark as touched
      });
    }
  }, [hasFormContext, clientValue, setValue]);

  return (
    <div className={classNames(styles.compCardContainer)}>
      <div
        className={classNames(styles.compCardTitleContainer)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', paddingBottom: '3px' }}
        onClick={() => setOpen((o) => !o)}
      >
        <span className={classNames(styles.dividerTextLarge)}>COMPANY DETAILS</span>
        <span
          style={{
            fontSize: 32,
            userSelect: 'none',
            transition: 'transform 0.2s',
            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
            color: '#9a9a9a',
            display: 'flex',
            alignItems: 'center',
            marginTop: '-4px'
          }}
        >
          ⌄
        </span>
      </div>
      <div className={classNames(styles.compCardContent)} style={{ display: open ? 'block' : 'none' }}>
        <span className={classNames(styles.inputTitle)}>
          Who is this job post for?<span className={requiredStyles.required}>*</span>
          <div className={classNames(styles.textSmall)}>{'Select a client!'}</div>
        </span>
                {isFetchingClients ? (
          <p>Loading...</p>
        ) : (
          <div className={classNames(styles.fieldWrapper)}>
            <SelectInput 
              options={clients} 
              name="client_id" 
              required={true}
              searchable={true}
              placeholder="Select client..."
              originalValue={clientValue}
              onChange={(name, selectedOption) => {
                // When user changes selection, update the form value if form context is available
                if (hasFormContext) {
                  setValue(name, selectedOption.value, { 
                    shouldValidate: true,
                    shouldDirty: true
                  });
                }
              }}
            />
          </div>
        )}
      </div>
      <JobClientForm show={!isEmpty(clientValue) || showClientForm} />
    </div>
  );
};
